import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AchooKeyworkInputFieldComponent} from '../../../core/achoo-keywork-input-field/achoo-keywork-input-field.component';
import {ProjectService} from '../../../services/project/project.service';
import {Project} from '../../../../models/project/project';
import {UserService} from '../../../services/user.service';
import {ValidationHandlerService} from '../../../core/validation-handler.service';
import {ErrorTemplate} from '../../../../models/ErrorTemplate';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../../services/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';
import {
  EventTrackerService, Page, UserActionType, ActionSource,
  TargetType, ActionDetails
} from '../../../services/event-tracker/event-tracker.service';
import {CommonConstant} from '../../../app.constants';
import { ActivePage } from '../../../../models/event-tracker';
import {BlockedReason, InvalidAction, WallType} from '../../../../models/user';

@Component({
  selector: 'edit-project',
  templateUrl: './edit-project.component.html',
  styleUrls: ['./edit-project.component.scss']
})
export class EditProjectComponent {
  @ViewChild('mentionInput')
  public mentionInput: AchooKeyworkInputFieldComponent;
  @ViewChild('NotificationAfterProjectUpdateSuccess')
  public notificationAfterProjectUpdateSuccess: AchooPopupComponent;
  @ViewChild('WarningCancelEditProject')
  public warningCancelEditProject: AchooPopupComponent;

  @Input()
  public project: Project;
  @Input()
  public countryList: any[] = [];
  @Input()
  public showCountryList = true;
  @Output()
  public closeBottomBarCallback: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  public activePage: ActivePage;
  @Output() beforeCreateOrUpdateProject: EventEmitter<any> = new EventEmitter<any>();

  public canCreateOrUpdateProject = true;

  constructor(private projectService: ProjectService,
              private userService: UserService,
              private validateErrorHandler: ValidationHandlerService,
              private modalService: ModalService,
              private translate: TranslateService,
              private eventTracker: EventTrackerService) { }

  closeEditProject() {
    this.modalService.close();
    this.closeBottomBarCallback.emit({isReloadList: false});
  }

  beforeAddingNewMontion(mention) {
    this.canCreateOrUpdateProject = false;
  }

  afterAddingNewMentionForProject(mention) {
    this.canCreateOrUpdateProject = true;
  }

  createOrEditProject() {
    // disable button create/update
    this.canCreateOrUpdateProject = false;
    const isCreated = this.project.id <= 0;
    this.project.advertiserId = this.userService.getCompanyId();
    this.project.keywords = this.mentionInput.mentions;

    if (this.mentionInput.countries.length > 0) {
      this.project.countries = this.mentionInput.countries;
    } else {
      this.project.countries = [CommonConstant.INTERNATIONAL_ID];
    }

    const errors: ErrorTemplate[] = this.projectService.validateProject(this.project);

    if (errors.length > 0) {
      this.validateErrorHandler.shouldDisplayErrors(true);
      this.validateErrorHandler.updateErrors(errors);
      // enable button create/update
      this.canCreateOrUpdateProject = true;
    } else {
      this.beforeCreateOrUpdateProject.emit();
      this.projectService.createOrEditProject(this.project).subscribe(res => {
        if (!res || !res.data) {
          return;
        }
        // reload project list
        const data = {
          isReloadList: true,
          isCreatedNew: isCreated,
          projectId: res.data.id,
          projectName: res.data.name,
          projectData: res.data
        };
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.PROJECT, {
          id: res.data.id,
          name: res.data.name,
          type: Page.PROJECT
        }, {
          action: UserActionType.CREATE,
          source: ActionSource.ACTION_VIEW,
          ...this.project
        }, undefined, {
          type: this.activePage && this.activePage.type,
          name: this.activePage && this.activePage.name,
          id: this.activePage && this.activePage.id
        });
        // close bottombar
        if (this.closeBottomBarCallback.observers.length > 0) {
          this.closeBottomBarCallback.emit(data);
        } else {
          this.projectService.triggerCreateOrUpdateProject(this.project);
        }
        this.modalService.open(this.notificationAfterProjectUpdateSuccess, null, true);
        // enable button create/update
        this.canCreateOrUpdateProject = true;
      }, err => {
        this.closeBottomBarCallback.emit({
          isError: true,
          isCreated: isCreated
        });
        if (err.error.data === 'invalid_level') {
          this.userService.doInvalidActionByLevel('Add Mention', err.error.message);
          this.sendInvalidActionToSegment();
        }
        // enable button create/update
        this.canCreateOrUpdateProject = true;
      });
    }
  }

  private sendInvalidActionToSegment() {
    const maxValue = this.userService.maxListeningMentions;
    const desiredValue = this.project.keywords.length;
    const detailAction = new InvalidAction(true, BlockedReason.ACCOUNT_WALL, WallType.USAGE_LIMIT, 'Project Mention Limit', true,
      maxValue, desiredValue, this.userService.accountLevelName);
    this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.PROJECT, {
      id: this.project.id,
      name: this.project.name,
      type: TargetType.PROJECT
    }, {
      action: UserActionType.UPDATE,
    }, undefined);
  }

  closeNotification(e) {
    this.modalService.close();
  }

  closeWarningPopup() {
    this.modalService.close();
  }

  showWarningBeforeCancelingProject() {
    this.modalService.openInCenter(this.warningCancelEditProject);
  }

  getNotificationContent() {
    if (this.project && this.project.id > 0) {
      return this.translate.instant('project.save_success');
    } else {
      return this.translate.instant('project.create_success');
    }
  }

  get actionSource() {
    return ActionSource.ACTION_VIEW;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/edit-project/edit-project.component.ts